import {
  getDashboardShipped,
  getDashboardPurchasing,
  getDashboardSales,
  getDashboardToShip,
  getDashboardReturns,
  getDashboardCreditNotes,
  getDashboardSalesMargins
} from "src/core/api/apiRequests";
import useResponse from "src/core/api/useResponse";
import {
  isServerAtLeast
} from "src/shared/environment";
import {
  getCurrencies
} from "src/pages/dashboard/helpers/getCurrencies";

// Dashboard metrics
export const useGetDashboardSales = (fromDate: string, toDate: string) => {
    const { rows: result } = useResponse<any[]>({
      requestFunction: getDashboardSales,
      values: { fromDate, toDate},
      requestNothingOnNull: false,
    });
  //  console.log('useGetDashboardSales', result);
    return result;
  };
  
  export const useGetDashboardReturns = (fromDate: string) => {
    const { rows: result } = useResponse<any[]>({
      requestFunction: getDashboardReturns,
      values: { fromDate },
      requestNothingOnNull: false,
    });
   // console.log('useGetDashboardReturn', result);
    return result;
  };
  
  export const useGetDashboardShipped = (fromDate: string,  toDate: string) => {
    const { rows: result } = useResponse<any[]>({
      requestFunction: getDashboardShipped,
      values: { fromDate, toDate },
      requestNothingOnNull: false,
    });
   // console.log('useGetDashboardDispatched', result);
    return result;
  };
  
  export const useGetDashboardToShip = (fromDate: string) => {
    const { rows: result } = useResponse<any[]>({
      requestFunction: getDashboardToShip,
      values: { fromDate },
      requestNothingOnNull: false,
    });
  //  console.log('useGetDashboardToShip', result);
    return result;
  };
  
  export const useGetDashboardPurchasing = (fromDate: string) => {
    const { rows: result } = useResponse<any[]>({
      requestFunction: getDashboardPurchasing,
      values: { fromDate },
      requestNothingOnNull: false,
    });
   // console.log('useGetDashboardPurchasing', result);
    return result;
  };
  
  export const useGetDashboardCreditNotes = (fromDate: string) => {
    const { rows: result } = useResponse<any[]>({
      requestFunction: getDashboardCreditNotes,
      values: { fromDate },
      requestNothingOnNull: false,
    });
    //console.log('useGetDashboardCreditNotes', result);
    return result;
  };

//useGetDashboardSalesMargins
export const useGetDashboardSalesMargins = (fromDate: string, toDate: string) => {
  const { rows: result } = useResponse<any[]>({
    requestFunction: getDashboardSalesMargins,
    values: isServerAtLeast(3) ? { fromDate, toDate } : null,
    requestNothingOnNull: true,
  });

  //console.log('useGetDashboardSalesMargins', result);
  return result;
};

// Existing external-currency demo hook
export const useGetSalesItemBySku = () => {
    const { rows: response } = useResponse<any>({
        requestFunction: getCurrencies,
    });
    return response;
}
